import 'babel-polyfill';
import fetchAPI from 'utils/fetchAPI';

export const REQUEST_ALL_DATA = 'REQUEST_ALL_DATA';
export const REQUEST_SINGLE_DATA = 'REQUEST_SINGLE_DATA';
export const RECEIVE_ALL_DATA = 'RECEIVE_ALL_DATA';
export const RECEIVE_SINGLE_DATA = 'RECEIVE_SINGLE_DATA';
export const SET_CURRENT_PRODUCT = 'SET_CURRENT_PRODUCT';
export const REQUEST_MORE_SINGLE_DATA = 'REQUEST_MORE_SINGLE_DATA';
export const RECEIVE_MORE_SINGLE_DATA = 'RECEIVE_MORE_SINGLE_DATA';
export const REQUEST_CONVERT_RATE = 'REQUEST_CONVERT_RATE';
export const RECEIVE_CONVERT_RATE = 'RECEIVE_CONVERT_RATE';

function requestConvertRate() {
  return {
    type: REQUEST_CONVERT_RATE,
  };
}

function receiveConvertRate(data) {
  return {
    type: RECEIVE_CONVERT_RATE,
    data,
  };
}

function requestAllData() {
  return {
    type: REQUEST_ALL_DATA,
  };
}

export function setCurrentProduct(id) {
  return {
    type: SET_CURRENT_PRODUCT,
    id,
  };
}

function receiveAllData(data) {
  return {
    type: RECEIVE_ALL_DATA,
    data,
    receivedAt: Date.now(),
  };
}

function requestSingleData() {
  return {
    type: REQUEST_SINGLE_DATA,
  };
}

function receiveSingleData(data, id, from, size) {
  return {
    type: RECEIVE_SINGLE_DATA,
    data,
    receivedAt: Date.now(),
    id,
    from,
    size,
  };
}

function requestMoreSingleData() {
  return {
    type: REQUEST_MORE_SINGLE_DATA,
  };
}

function receiveMoreSingleData(data, id, from, size) {
  return {
    type: RECEIVE_MORE_SINGLE_DATA,
    data,
    receivedAt: Date.now(),
    id,
    from,
    size,
  };
}

export function fetchAllData() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch(requestAllData());

      const token = getState().users.token;
      fetchAPI({
        endpoint: '/credit/subscription/feed',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then(response =>
        response.json().then(json => {
          if (response.status === 200) {
            dispatch(receiveAllData(json));
            resolve(json);
          } else {
            reject(response);
          }
        })
      );
    });
}

const getFromAndSize = string => {
  if (!string) {
    return {
      from: '',
      size: '',
    };
  }

  const index = string.indexOf('?');
  const updateStr = string.substring(index);
  const array = updateStr.split('&');
  const from = array[0].split('=')[1];
  const size = array[1].split('=')[1];
  return { from, size };
};

export function fetchProductDetail(id) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch(requestSingleData());

      const token = getState().users.token;
      fetchAPI({
        endpoint: `/credit/products/${id}/prices`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(json => {
          const object = getFromAndSize(json.paging.next);
          const from = object.from;
          const size = object.size;
          dispatch(receiveSingleData(json, id, from, size));
          resolve(json);
        });
    });
}

export function fetchMoreProductDetail(id, from, size) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch(requestMoreSingleData());

      const token = getState().users.token;
      fetchAPI({
        endpoint: `/credit/products/${id}/prices?from=${from}&size=${size}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(json => {
          const object = getFromAndSize(json.paging.next);
          const from = object.from;
          const size = object.size;
          dispatch(receiveMoreSingleData(json, id, from, size));
          resolve(json);
        });
    });
}

export function fetchConvertRate(timeStamp) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch(requestConvertRate());

      fetchAPI({
        endpoint: `/exchange_rates?from_timestamp=${timeStamp}`,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => response.json())
        .then(json => {
          dispatch(receiveConvertRate(json));
          resolve(json);
        });
    });
}

/** SUPERSEDED */
export function fetchExpiryDate() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;
      fetchAPI({
        endpoint: '/self/data_subscription',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(json => {
          if (json.error_code) {
            reject(json.error_message);
          } else {
            resolve(json);
          }
        });
    });
}

export function getSubscriptionInfo() {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const token = getState().users.token;
      fetchAPI({
        endpoint: '/credit/subscription',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(response => response.json())
        .then(json => {
          if (json.error_code) {
            reject(json.error_message);
          } else {
            resolve(json);
          }
        });
    });
}

export const POPUPS = {
  CREDIT_TERMS: 'CREDIT_TERMS',
};

export function showPopup(key) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const userId = getState().users.user.id;
      const token = getState().users.token;
      fetchAPI({
        endpoint: `/users/popup/check?popup_key=${key}`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(res => res.json())
        .then(json => {
          if (json.status) return resolve(json.status === 0);
          return reject();
        });
    });
}



// WEBPACK FOOTER //
// ./app/actions/DataPageActionCreators.js